import { screenForPath } from './screenAccess';

/**
 * The class list for a link shown as plain text (`ScreenLink`): layout and
 * type stay, everything that says "this is a link" goes (link colour,
 * underline, hover / focus styles, pointer). `null` for a button-styled link:
 * an action into a closed screen is removed, not shown as dead text.
 */
const LINK_ONLY = [
  /^(hover|focus|focus-visible|focus-within|active|group-hover|group-focus-visible|visited):/,
  /^underline(-offset-\d+)?$/,
  /^no-underline$/,
  /^text-(primary|accent)(-[a-z0-9-]+)?$/,
  /^cursor-pointer$/,
  /^transition(-[a-z,[\]-]+)?$/,
  /^duration-[a-z0-9-]+$/,
  /^dt-link$/,
];

export function linkFallback(className: string | undefined): string | null {
  const tokens = (className ?? '').split(/\s+/).filter(Boolean);
  if (tokens.some((c) => c === 'btn' || c.startsWith('btn-'))) return null;
  return tokens.filter((c) => !LINK_ONLY.some((re) => re.test(c))).join(' ');
}

/**
 * What a closed link becomes (`ScreenLink`): `null` = nothing (a link to the
 * screen itself names it; a button is an action; `closed="hide"`), otherwise
 * the class list of the plain-text stand-in.
 */
export function closedLink(to: string, className: string | undefined, closed: 'text' | 'hide' = 'text'): string | null {
  if (closed === 'hide' || screenForPath(to)?.exact) return null;
  return linkFallback(className);
}
